import { AfterViewInit, Component, OnInit, ViewChild } from '@angular/core';
import { ServicesService } from '../services.service';
import { Observable } from 'rxjs/Observable';
import { DataSource } from '@angular/cdk/collections';
import { User } from '../models/fileCode.model';
import { MatTableDataSource, MatPaginator, MatSort } from '@angular/material';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import {HttpErrorResponse} from '@angular/common/http';
// import { patternValidator } from 'app/shared/pattern-validator';
import swal from 'sweetalert2';
import {Router} from '@angular/router';


@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.css']
})
export class DashboardComponent implements OnInit, AfterViewInit {

    dataSource       = new MatTableDataSource();
   // dataSource       = MyDataSource || null;
    displayedColumns = [ 'name', 'description', 'date', 'filecode'];
    header           = 'l-header';
    navbar           = 'l-navbar l-navbar_t-light l-navbar_expand js-navbar-sticky';
    fileForm: FormGroup;

    constructor(private _services: ServicesService , private router: Router) {   }

    @ViewChild(MatPaginator) paginator: MatPaginator;
    @ViewChild(MatSort) sort: MatSort;

    ngOnInit() {
         // this.dataSource.data = ELEMENT_DATA;
       // this.dataSource = new MyDataSource();
        this.getUserFile();
        this.createForm();
    }

    ngAfterViewInit() {
         this.dataSource.paginator = this.paginator;
         this.dataSource.sort = this.sort;
    }


    private createForm() {
        this.fileForm = new FormGroup({
            // tslint:disable-next-line
            fName: new FormControl('', [Validators.required, Validators.maxLength(20)]),
            lName: new FormControl('', [Validators.required, Validators.maxLength(20)]),
            description: new FormControl('', [Validators.required, Validators.maxLength(20)]),
            fileName: new FormControl('', Validators.required),
        });
    }
    public saveFileName() {

        const userData = JSON.parse(localStorage.getItem('userData'));
        // userData.hasOwnProperty('id')
        this.fileForm.value.user_id = userData ? userData.id : '';
        // console.log(this.fileForm.value);
        this._services.saveFileName(this.fileForm.value).subscribe((data: any) => {
                if (data.status ==200) {
                    var d = new Date();
                    var strDate = d.getDate() + "/" + (d.getMonth()+1) + "/" + d.getFullYear();
                    this.dataSource.data.push({user_id: this.fileForm.value.user_id, name:(this.fileForm.value.fName+' '+this.fileForm.value.lName), description: this.fileForm.value.description, date: strDate, fileName:this.fileForm.value.fileName});
                    swal({
                        title: 'Congratulations!',
                        text: 'Your file name has been added successfully',
                        type: 'success',
                        confirmButtonText: 'Ok',
                    });
                }else {
                    swal({
                        title: 'Opps!',
                        text: 'Something went wrong',
                        type: 'error',
                        confirmButtonText: 'Ok',
                    });
                }
                setTimeout(() => {
                    this.fileForm.reset();
                },2000);
            },
            (err: HttpErrorResponse) => {
                swal({
                    title: 'Opps!',
                    text: 'Something went wrong',
                    type: 'error',
                    confirmButtonText: 'Ok',
                });
            });
        // this.dataSource.data.push(this.fileForm.value);
    }

    public getUserFile() {
        // const userData = JSON.parse(localStorage.getItem('userData'));
        const token    = localStorage.getItem('userToken');
        // userData.hasOwnProperty('id')
       // const user_id = userData ? userData.id : '';
        this._services.getUserFile({token: token}).subscribe((data: any) => {

                $('.tb-preloader-wave').fadeOut();
                $('#tb-preloader').delay(200).fadeOut('slow').remove();

                if (data.status === 200) {
                    // console.log(data.result)
                    this.dataSource.data = data.result;
                    // this.dataSource = new MyDataSource();
                }else {
                    this.dataSource.data = [];
                    // this.router.navigate(['login']);
                }
            },
            (err: HttpErrorResponse) => {

            });
    }

    applyFilter(filterValue: string) {
        filterValue = filterValue.trim(); // Remove whitespace
        filterValue = filterValue.toLowerCase(); // MatTableDataSource defaults to lowercase matches
        this.dataSource.filter = filterValue;
    }



  }
export interface Element {
    name: string;
    position: number;
    description: string;
    date: string;
    filecode: string;
}

// const ELEMENT_DATA: Element[] = [
//     {position: 1, name: 'James', description: 'Class 12th 2015', date: '22 MAR 2018', filecode: 'HJHK434-55'},
//     {position: 2, name: 'Andrew', description: 'Class 10th 2013', date: '01 APRIL 2020', filecode: 'LOEP-K434-55'},
//     {position: 3, name: 'Andrew', description: 'Class 10th 2013', date: '01 APRIL 2020', filecode: 'LOEP-K434-55'},
//     {position: 4, name: 'Andrew', description: 'Class 10th 2013', date: '01 APRIL 2020', filecode: 'LOEP-K434-55'},
//     {position: 5, name: 'Andrew', description: 'Class 10th 2013', date: '01 APRIL 2020', filecode: 'LOEP-K434-55'},
//     {position: 6, name: 'Andrew', description: 'Class 10th 2013', date: '01 APRIL 2020', filecode: 'LOEP-K434-55'},
//     {position: 7, name: 'Andrew', description: 'Class 10th 2013', date: '01 APRIL 2020', filecode: 'LOEP-K434-55'},
//     {position: 8, name: 'Andrew', description: 'Class 10th 2013', date: '01 APRIL 2020', filecode: 'LOEP-K434-55'},
//     {position: 9, name: 'Andrew', description: 'Class 10th 2013', date: '01 APRIL 2020', filecode: 'LOEP-K434-55'},
//     {position: 10, name: 'Andrew', description: 'Class 10th 2013', date: '01 APRIL 2020', filecode: 'LOEP-K434-55'},
//     {position: 11, name: 'Andrew', description: 'Class 10th 2013', date: '01 APRIL 2020', filecode: 'LOEP-K434-55'},
//     {position: 12, name: 'Andrew', description: 'Class 10th 2013', date: '01 APRIL 2020', filecode: 'LOEP-K434-55'},
// ];


//  export class MyDataSource extends DataSource<any[]> {
//     data = [
//             {position: 1, name: 'James', description: 'Class 12th 2015', date: '22 MAR 2018', filecode: 'HJHK434-55'},
//             {position: 2, name: 'Andrew', description: 'Class 10th 2013', date: '01 APRIL 2020', filecode: 'LOEP-K434-55'}
//            ];
//     constructor() {
//         super();
//     }
//     connect(): Observable<any[]> {
//         return this.userService.getFileCodes();
//     }
//     disconnect(): void {
//
//     }
// }



// WEBPACK FOOTER //
// /var/www/html/oneills-web-qa/src/app/dashboard/dashboard.component.ts